export { ProjectionPage as default } from '@/components/enpages/Ir/Library/Projection'
